var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgText = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  width: 14,
  height: 14,
  fill: "none"
}, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
  clipPath: "url(#text_svg__a)",
  opacity: 0.4
}, /*#__PURE__*/React.createElement("path", {
  stroke: "#000",
  strokeLinecap: "square",
  strokeLinejoin: "round",
  strokeWidth: 1.002,
  d: "M10.076 1.335H3.277c-1.072 0-1.942.87-1.942 1.943v6.798c0 1.073.87 1.942 1.942 1.942h6.799c1.072 0 1.942-.87 1.942-1.942V3.278c0-1.073-.87-1.943-1.942-1.943Z"
}), /*#__PURE__*/React.createElement("path", {
  fill: "#000",
  d: "M6.125 9.059c-.878 0-1.545-.568-1.545-1.399 0-.84.645-1.325 1.798-1.394l1.162-.07v-.305c0-.43-.3-.68-.774-.68-.383 0-.616.125-.895.487a.63.63 0 0 1-.5.232c-.305 0-.525-.198-.525-.482 0-.099.022-.19.065-.284.215-.55.955-.89 1.91-.89 1.184 0 1.954.61 1.954 1.54v2.63c0 .417-.253.632-.61.632-.34 0-.577-.19-.603-.56V8.28h-.026c-.258.49-.835.779-1.411.779m.413-.908c.55 0 1.002-.358 1.002-.857V6.96l-.972.06c-.47.034-.736.245-.736.572 0 .344.284.56.706.56"
}))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
  id: "text_svg__a"
}, /*#__PURE__*/React.createElement("path", {
  fill: "#fff",
  d: "M0 0h13.354v13.354H0z"
})))));
export default SvgText;